import { getStyle } from './getStyle';
import { getThgText } from '../../../../main/functions/thg/getThgText';
import * as React from 'react';
import { WpdfText } from '../../pdf/WpdfText.';
import { WpdfView } from '../../pdf/WpdfView';

export function getVorwort(
    isPdf: boolean, getPageNum: (key: string, page: number, level: number) => void, data: any, jahr: number, standort?: number
): JSX.Element {
    const keys: string[] = ['vorwort_absatz1', 'vorwort_absatz2', 'vorwort_absatz3', 'vorwort_absatz4'];

    return (
        <WpdfView pdf={isPdf}>
            <WpdfText
                pdf={isPdf}
                style={{ ...getStyle('h1', isPdf), ...(isPdf && { marginTop: 0 }) }}
                getPageNum={(pageNumber: number) => typeof getPageNum === 'function' && getPageNum('1. Vorwort', pageNumber, 1)}
            >
                1. Vorwort
            </WpdfText>
            {keys.map((key: string, index: number) =>
                <WpdfText key={`vorwort_${index}`} style={getStyle('div')} pdf={isPdf}>
                    {getThgText(key, data, jahr, standort)}
                </WpdfText>
            )}
            {/*
            <WpdfText style={{ ...getStyle('div'), ...getStyle('bold', isPdf), marginTop: '15pt' }} pdf={isPdf}>
                Fußnote:
            </WpdfText>
            */}
            <WpdfText style={getStyle('div')} pdf={isPdf}>
                {getThgText('vorwort_fussnote1', data, jahr, standort)}
            </WpdfText>
        </WpdfView>
    );
}
